import {
  captureProductEvent,
  identifyProductUser,
  resetProductUser,
  trackCreditsInsufficient,
  trackCvAnalysisCompleted,
  trackCvAnalysisFailed,
  trackCvAnalysisStarted,
  trackSubscriptionCtaClick,
  trackUserLoggedIn,
  trackUserRegistered,
} from './productAnalytics';

// Configuration Google Tag Manager
export const GTM_ID = 'GTM-N6SNBTMF';

// Initialisation de GTM
export const initGA = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname + window.location.search
        });
    } else if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: 'page_view',
            page_title: document.title,
            page_location: window.location.href,
            page_path: window.location.pathname + window.location.search
        });
    }
};

// Suivi des pages
export const pageview = (url) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', 'page_view', {
            page_path: url
        });
    } else if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: 'page_view',
            page_path: url,
        });
    }
};

// Suivi des événements
export const event = ({ action, category, label, value }) => {
    if (typeof window !== 'undefined' && window.gtag) {
        const params = { event_category: category };
        if (label) params.event_label = label;
        if (typeof value !== 'undefined') params.value = value;
        window.gtag('event', action, params);
    } else if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
            event: action,
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

// Événements spécifiques à CV Analyzer
export const trackCVUpload = (sector) => {
    event({
        action: 'cv_upload',
        category: 'engagement',
        label: sector,
    });
    trackCvAnalysisStarted({ sector, file_type: 'upload' });
};

export const trackCVAnalysis = (score, sector, extra = {}) => {
    event({
        action: 'cv_analysis_complete',
        category: 'engagement',
        label: sector,
        value: score,
    });
    trackCvAnalysisCompleted({
        sector,
        score,
        ...extra,
    });
};

export const trackUserRegistration = (user) => {
    event({
        action: 'user_registration',
        category: 'conversion',
        label: 'new_user',
    });
    trackUserRegistered();
    if (user) identifyProductUser(user);
};

export const trackUserLogin = (user) => {
    event({
        action: 'user_login',
        category: 'engagement',
        label: 'returning_user',
    });
    if (user) identifyProductUser(user);
    trackUserLoggedIn();
};

export { identifyProductUser, resetProductUser, trackCreditsInsufficient, trackCvAnalysisFailed, trackSubscriptionCtaClick };

export const trackSubscription = (plan) => {
    event({
        action: 'subscription_purchase',
        category: 'conversion',
        label: plan,
    });
};

export const trackCreditPurchase = (amount) => {
    event({
        action: 'credit_purchase',
        category: 'conversion',
        label: 'credits',
        value: amount,
    });
};

export const trackFeatureUsage = (feature) => {
    event({
        action: 'feature_usage',
        category: 'engagement',
        label: feature,
    });
};

// Suivi des erreurs
export const trackError = (error, page) => {
    event({
        action: 'error',
        category: 'error',
        label: `${page}: ${error}`,
    });
};

// Suivi des performances
export const trackPerformance = (metric, value) => {
    event({
        action: 'performance',
        category: 'performance',
        label: metric,
        value: value,
    });
};

// CV Generator Analytics
export const trackCvGeneration = (action, templateId = null) => {
    event({
        action: 'cv_generation',
        category: 'cv_generator',
        label: action,
        value: templateId ? 1 : 0,
    });
};

export const trackCvExport = (format, templateId) => {
    event({
        action: 'cv_export',
        category: 'cv_generator',
        label: format,
        value: templateId ? 1 : 0,
    });
};

export const trackAbTest = (action, version = null) => {
    event({
        action: 'ab_test',
        category: 'cv_generator',
        label: action,
        value: version ? 1 : 0,
    });
}; 